// const BASE_URL = 'http://clientms.credixcm.com:8089/'
//const API_SERVICE = "https://clientms.credixcm.com/";
const UPLOAD_DOCUMENT = "https://webtechcare.credixcm.com";
const ACCOUNTS = "https://techcare-account.credixcm.com";
const GATEWAY = "https://techcare-gateway.credixcm.com/techCareApiService/request";
const CLIENT = `https://techcare-client.credixcm.com/`;
const LOGIN = "https://techcare-gateway.credixcm.com/";

export const BASE_URL = {
  AP: CLIENT,
  UP: UPLOAD_DOCUMENT,
  AC: ACCOUNTS,
  GATEWAY: GATEWAY,
  CLIENT: CLIENT,
  LOGIN: LOGIN,
};
